import { Component, OnInit } from '@angular/core';
import { Modal } from 'src/app/models/Modal.model';
import { ModalNames } from '../Modal';

@Component({
    templateUrl: './time-popup.modal.html'
})
export class TimePopupModalComponent extends Modal implements OnInit {

    public timer = '';
  
    private setTimer(): void {
        this.timer = localStorage.getItem('timerHTML');
    }

    ngOnInit(): void {
        this.setTimer();
        setInterval(this.setTimer.bind(this), 1000);
    }

    onInjectInputs(): void {
        return null;
    }

    allowDimmerClose(): boolean {
        return false;
    }
  
    getName(): ModalNames {
        return ModalNames.TIMER;
    }
}